import React from 'react'
import logo from '../../../assets/images/logoRedimensionado.png'

const LogoSection = () => (
    <div className="text-center">
        <div className="relative inline-block mb-8">
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-3xl blur-lg opacity-20 animate-pulse"></div>
            <div className="relative bg-white rounded-3xl shadow-2xl border border-gray-100">
                <img 
                    className="w-full h-auto" 
                    src={logo} 
                    alt="VoxCity ERP" 
                />
            </div>
        </div>
    </div>
)

export default LogoSection